module.exports = __webpack_public_path__ + "img/employeeManagement.89aa4b19.svg";